export default "__VITE_ASSET__89fce0db__"